import React, { useCallback } from 'react';

import { FieldBag } from './select.types';

type EventHandler = (event: React.SyntheticEvent<HTMLSelectElement>) => any;
type BagHandler = (bag: FieldBag) => any;

export function useHandlerAdapter(handler?: BagHandler): EventHandler {
  return useCallback(
    (event): void => {
      handler?.({
        name: event.currentTarget.name,
        value: event.currentTarget.value,
      });
    },
    [handler],
  );
}
